module["exports"] = [
  "zu",
  "von",
  "vom",
  "von der"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/name/nobility_title_prefix.js
// module id = 2002
// module chunks = 2